import { createApp } from 'vue'

// Unregister any stale service workers in development so cached JS never runs old routing code
if (import.meta.env.DEV && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((r) => r.unregister())
  })
}

import { createPinia } from 'pinia'
import { Tooltip } from 'bootstrap'
import App from './App.vue'
import router from './router'
import { createSentryPiniaPlugin } from '@sentry/vue'

import ApiService from '@/core/services/ApiService'
import { initInlineSvg } from '@/core/plugins/inline-svg'
import { initKtIcon } from '@/core/plugins/keenthemes'
import { initApexCharts } from '@/core/plugins/apexcharts'
import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'
import Aura from '@primeuix/themes/aura'
import * as Sentry from '@sentry/vue'

import '@/core/plugins/prismjs'
import '@vuepic/vue-datepicker/dist/main.css'
// Remove fixed theme import - we'll load it dynamically

const app = createApp(App)
const pinia = createPinia()
pinia.use(createSentryPiniaPlugin())

Sentry.init({
  app,
  dsn: import.meta.env.VITE_APP_SENTRY_DSN,
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', import.meta.env.VITE_APP_API_URL],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
})

app.use(pinia)
app.use(router)
app.use(PrimeVue, {
  theme: {
    preset: Aura, // Use the Aura theme preset
    options: {
      prefix: 'p',
      darkModeSelector: '.app-dark', // Use the app-dark class for dark mode
      cssLayer: false
    }
  },
  zIndex: {
    dialog: 2100,
    overlay: 2000,
    menu: 2000,
    tooltip: 2200
  }
})

app.use(ToastService)
ApiService.init(app)
initApexCharts(app)
initInlineSvg(app)
initKtIcon(app)
app.directive('tooltip', (el) => {
  new Tooltip(el)
})

app.mount('#app')
